"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageContentSlim = void 0;
const utils_1 = require("./utils");
const getClient_1 = require("./utils/getClient");
const getContentfulEntries_1 = require("./utils/getContentfulEntries");
const transformObjectToRemoveFields_1 = require("./utils/transformObjectToRemoveFields");
/**
 * Get content for a page with global elements dictionary and metadata removed
 */
const getPageContentSlim = async ({ space, accessToken, host, contentType, slug, locale, environment, trackingApplicationName }) => {
    const client = (0, getClient_1.getClient)({ space, accessToken, host, environment });
    const content = await (0, getContentfulEntries_1.getContentfulEntries)({
        client,
        contentType,
        slug,
        locale,
        space,
        trackingApplicationName
    });
    return (0, utils_1.mapContentfulPageData)((0, transformObjectToRemoveFields_1.transformObjectToRemoveFields)(content.items[0]));
};
exports.getPageContentSlim = getPageContentSlim;
//# sourceMappingURL=getPageContentSlim.js.map